import styled from 'styled-components'

interface IExternalPaymentMethodFormStyledProps {}

export const ExternalPaymentMethodFormStyled = styled.div<IExternalPaymentMethodFormStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  height: 100%;

  display: flex;
  flex-direction: column;
`
